module.exports = __webpack_public_path__ + "static/img/my_subscribe.37ba9bc7.png";